import { normaliseJobServiceSnapshot } from './utils'

export function hasReviewedReport(job) {
  return normaliseJobServiceSnapshot(job?.service_snapshot).some(line => line?.vat_source === true)
}
export async function loadReviewedReportHistory(db, job) {
  const {data,error}=await db.rpc('workshop_vat_report_history',{p_job_id:job.id})
  if(error)return {data:null,error}
  if(data?.job_id!==job.id || data.workshop_id!==job.workshop_id)return {data:null,error:{message:'Report history scope could not be verified.'}}
  return {data:data.reports || [],error:null}
}
export function reportDeliveryLabel(state) {
  return ({sent:'Emailed report',sending:'Email sending',uncertain:'Delivery outcome uncertain',failed:'Email failed'})[state] || 'Saved PDF report'
}
export function recordedReportSentAt(data) {
  if(data.report_version?.vat_snapshot_id && !data.report_sent_at)throw new Error('Recorded report delivery time is unavailable. Reload its history; do not resend.')
  return data.report_sent_at || new Date().toISOString()
}

export function reportDisplayTime(version) {
  return version.vat_snapshot_id ? (version.delivery_status === 'sent' ? version.sent_at : null) : version.sent_at || version.created_at
}
